// src/api/disputaApi.ts

import client from './client';
import { ApiResponse, PageResponse } from '../types';

// ─── Tipos ─────────────────────────────────────────────────────────────────────

export type EstadoDisputa = 'ABIERTA' | 'EN_REVISION' | 'RESUELTA' | 'CERRADA';
export type RolAutorDisputa = 'CLIENTE' | 'MVZ';

export interface Disputa {
  id: string;
  solicitudId: string;
  servicioNombre?: string;
  metodoPago?: string;
  autorUserId: string;
  autorNombre: string;
  rolAutor: RolAutorDisputa;
  notificadoUserId?: string;
  notificadoNombre?: string;
  asunto: string;
  descripcion: string;
  respuesta?: string;
  fechaRespuesta?: string;
  resolucionAdmin?: string;
  favorDe?: string;
  fechaResolucion?: string;
  estado: EstadoDisputa;
  fechaApertura: string;
  createdDate?: string;
}

export interface ResolverDisputaRequest {
  resolucion: string;
  favorDe: 'CLIENTE' | 'MVZ' | 'NINGUNO';
}

// ─── API calls ─────────────────────────────────────────────────────────────────

export const getDisputasAdmin = async (
  estado?: string,
  page = 0,
  size = 20,
): Promise<any> => {
  const params: Record<string, any> = { page, size };
  if (estado) params.estado = estado;
  const res = await client.get('/api/v1/admin/disputas', { params });
  return res.data;
};

export const resolverDisputa = async (
  id: string,
  request: ResolverDisputaRequest,
): Promise<ApiResponse<Disputa>> => {
  const res = await client.put(`/api/v1/admin/disputas/${id}/resolver`, request);
  return res.data;
};

export const cerrarDisputa = async (
  id: string,
  motivo?: string,
): Promise<ApiResponse<Disputa>> => {
  const res = await client.put(`/api/v1/admin/disputas/${id}/cerrar`, null, {
    params: motivo ? { motivo } : {},
  });
  return res.data;
};

export const getDisputaStats = async (): Promise<{ abiertas: number }> => {
  const res = await client.get('/api/v1/admin/disputas/stats');
  return res.data?.content ?? { abiertas: 0 };
};

export const getDisputaDetalle = async (id: string): Promise<Disputa | null> => {
  const res = await client.get(`/api/v1/disputas/${id}`);
  return res.data?.content ?? null;
};

/**
 * Cambia el estado de una disputa (ej. ABIERTA → EN_REVISION).
 * Cuando el admin cambia a EN_REVISION, el backend envía FCM push a cliente y MVZ.
 */
export const cambiarEstadoDisputa = async (
  id: string,
  nuevoEstado: EstadoDisputa,
): Promise<ApiResponse<Disputa>> => {
  const res = await client.put(`/api/v1/admin/disputas/${id}/estado`, { nuevoEstado });
  return res.data;
};
